
import styled from 'styled-components'

const Wrapper = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: none !important;
    color: #FFF;
    width: 100%;
    height: 100%;

    .tooltip-mobile {
      position: absolute;
      display: flex;
      flex-direction: column;
      bottom: 46px;
      max-width: 40vw;
      padding: 2px 8px;
      font-size: 8px;
      letter-spacing: 1px;
      background: rgba(17,36,38,0.7);


      &.tooltip-left {
        left: -14px;
        &:after {
          content: '';
          position: absolute;
          left: 6px;
          top: 100%;
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid rgba(17, 36, 38, 0.8);
        }
      }

      &.tolltip-right {
        right: 14px;
        &:after {
          content: '';
          position: absolute;
          right: 10px;
          top: 100%;
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid rgba(17, 36, 38, 0.8);
        }
      }
    }
`

const ActionButton = styled.div`
  position: absolute;
  width: 34px;
  height: 34px;
  cursor:pointer;
  display: ${p => (p.active ? 'flex' : 'none')}; 
  align-items: center; 
  justify-content: space-between;
  right: ${p => (p.right ? "0" : 'unset')};
  left: ${p => (p.left ? "0" : 'unset')}; 
  /* top:${p => (p.position * 50)}px;  */
  top: 50vh;
  background: rgba(17,36,38,0.7);
  transition: all .3s ease;

  @media (min-width: 768px) and (max-height: 700px){
    top: 40vh;
  }

  .tooltip-enter {
    position: absolute;
    top: 40px;
    left: 50%;
    opacity: 0;
    transform: translate(-50%, -16px);
    width: 40px;
    height: 21px;
    background-repeat: no-repeat;
    transition: all .2s ease-out;
  }

  &:hover {
    background: rgba(17,36,38,1);
    .tooltip-enter {
      opacity: 1;
      transform: translate(-50%, 4px);
    }
  }
  > svg {
    width: 35px;
    ${p => p.isFavorite && (
      `
        -webkit-animation: scale 2s infinite  normal ease-out;
        animation: scale 2s infinite  normal ease-out;
      `
    )}
  }
  p {
    font-family: 'Amorim Sans Book', sans-serif;
    letter-spacing: 0.9px;
    color: #fff;
    margin: 0;
    word-break: normal;
  }
  &.mobile{
    height:50px;
    width: 48%;
     top: 0;
     pointer-events: all;
    /*bottom: 0;
    right: ${p => (p.right ? "-25px" : 'unset')};
    left: ${p => (p.left ? "-25px" : 'unset')};  */

    &:hover {
      background: rgba(17,36,38,0.8);
    }
  }
`;

export { ActionButton, Wrapper }